import useRedux from "./useRedux";
export default function useLocale() {
    const [{ locale }] = useRedux(state => ({
        locale: state.i18n.locale
    }));
    return locale;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/hooks/useLocale.ts